// import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';
// import { withStyles } from '@material-ui/core/styles';
// import '../../global/styles.scss';

export const globalStyle = theme => ({

  layout: {
      justifyContent: 'space-around',
      width: 'auto',
      [theme.breakpoints.down('xs')]: {
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(0),
      },
      [theme.breakpoints.down('sm')]: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
      },
      [theme.breakpoints.up(1160 + theme.spacing(3) * 2)]: {
        width: 1160,
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
  shapeCircle: {
    backgroundColor: theme.palette.primary.main,
    width: 40,
    height: 40, borderRadius: '50%', 
  },
  titlePage: {
    fontFamily: theme.typography.fontKanit,
    fontSize: '24px',
    fontWeight: 400,
  },
  titleSubPage: {
    fontFamily: theme.typography.fontKanit,
    fontSize: '14px',
    color: theme.palette.grey.main,
  },
  formControl: {
    fontFamily: theme.typography.fontKanit,
    margin: 0,
    fullWidth: true,
    display: 'flex',
    wrap: 'nowrap',
    fontSize: '14px',
  },
  buttonSelect: {
    fontSize: '14px',
  },
  btnDam: {
    borderRadius: 30,
  },
  active_btnDam: {
    color: '#fff !important',
    borderRadius: 30,
    backgroundColor: theme.palette.primary.main,
  },
  btnStyle: {
    borderRadius: 30,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
  },
  active_btnStyle: {
    color: '#fff !important',
    borderRadius: 30,
    backgroundColor: theme.palette.primary.main,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
  },
  formLableRadio: {
    fontWeight: 600,
  },
  pageHeader: {
    backgroundColor: theme.palette.primary.main,
    paddingTop: 20,
    paddingBottom: 20,
    width: '100% !important',
  },
  responsive: {
    width: '100%',
    height: '100%',
  },
});